import styled from 'styled-components'
import {DropdownContent} from '@components/ui/dropdown-atoms/DropdownAtoms.tsx'

export const StyledDropdownContent = styled(DropdownContent)`
    display: grid;
    grid-auto-rows: auto minmax(0, 1fr);
    overflow: hidden;
`
